var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center"},[_c('div',{staticStyle:{"font-size":"16px"}},[_c('strong',[_vm._v(_vm._s(_vm.title))])])]),_c('div',{staticStyle:{"width":"100%","height":"700px"},attrs:{"id":"chartdiv"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }